// src/constants/routes.js
// 함수는 동적 라우팅 기본값은 :name
export const ROUTES = {
  ROOT: '/', //완
  LOGIN: '/login', // 완
  SIGNUP: '/signup', // 완
  FIND_ACCOUNT: '/find-account', //완
  LOGOUT: '/logout', //완

  MAIN: (name = ':name') => `/main/${name}`, // 완
  HOME_MAIN: '/home/main', //완
  DIAGRAM: '/diagram', // 완
  SAMPLE: '/sample', // 완
  FLOW: '/flow', // 완
  TEST_TOOL: '/test-tool', // 완
  TEST_PATCH_MAP: '/test-patch-map', // 완

  PROJECT: {
    BASE: '/project', // 완
    MAIN: '/project/main', // 완
    CREATE: '/project/create', // 완
    MAP: '/project/map', // 완
    EDIT: (projectId = ':projectId') => `/project/edit/${projectId}`, // 완
  },

  SITE_MANAGER: {
    BASE: '/site-manager',
    MAIN: '/site-manager/main',
    CREATE: '/site-manager/create',
    EDIT: (managerId = ':managerId') => `/site-manager/edit/${managerId}`,
  },

  MEMBER: {
    BASE: '/member',
    MAIN: '/member/main',
    CREATE: '/member/create',
    EDIT: (memberId = ':memberId') => `/member/edit/${memberId}`,
  },

  PLANT_LIST: (projectId = ':projectId') => ({
    BASE: `/project/${projectId}/plant-list`, // 완
    MAIN: `/project/${projectId}/plant-list/main`, //완
    CREATE: `/project/${projectId}/plant-list/create`, // 구버전
    DETAIL: (plantId = ':plantId') => `/project/${projectId}/plant-list/detail/${plantId}`, // 구버전
    DRAWING: (plantId = ':plantId') => `/project/${projectId}/plant-list/drawing/${plantId}`, // 완
    DRAWING_V2: (plantId = ':plantId') => `/plant-list/drawing-v2/${plantId}`, // 구버전
    UPDATE: (plantId = ':plantId') => `/plant-list/${projectId}/update/${plantId}`, // 구버전
    EQUIP: (plantId = ':plantId') => `/project/${projectId}/plant-list/equip/${plantId}`, // 완 (구버전 미적용)

    SOLAR_CREATE: `/project/${projectId}/plant-list/solar/create`, // 완
    SOLAR_DETAIL: (plantId = ':plantId') => `/project/${projectId}/plant-list/solar/detail/${plantId}`, // 완 (fire Detection 미적용)
    SOLAR_EDIT: (plantId = ':plantId') => `/project/${projectId}/plant-list/solar/edit/${plantId}`, // 완

    POWER_CREATE: `/project/${projectId}/plant-list/power/create`,// 완
    POWER_DETAIL: (deviceId = ':deviceId') => `/project/${projectId}/plant-list/power/detail/${deviceId}`,// 구버전
    POWER_DETAIL_CARRIER: `/project/${projectId}/plant-list/power/detailcarrier`, // 완
    POWER_EDIT: (deviceId = ':deviceId') => `/project/${projectId}/plant-list/power/edit/${deviceId}`, // 완

    BATTERY_CREATE: `/project/${projectId}/plant-list/battery/create`,// 완
    BATTERY_EDIT: (plantId = ':plantId') => `/project/${projectId}/plant-list/battery/edit/${plantId}`, // 완
    BATTERY_DETAIL: (batteryId = ':batteryId') => `/project/${projectId}/plant-list/battery/detail/${batteryId}`, // 완
    BATTERY_GRAPH: (batteryId = ':batteryId') => `/project/${projectId}/plant-list/battery/graph/${batteryId}`, // 완
  }),

  PLANT_STATUS: (projectId = ':projectId') => ({
    BASE: `/project/${projectId}/plant-status`, // 완
    ISSUE_DETAIL: (plantId = ':plantId') => `/project/${projectId}/plant-status/issue/detail/${plantId}`, // 완 (구버전 미적용)
    ISSUE_DETAIL_OV: (plantId = ':plantId') => `/project/${projectId}/plant-status/issue/detail-ov/${plantId}`, // 구버전
    ISSUE_COMBINER: (plantId = ':plantId') => `/project/${projectId}/plant-status/issue/combiner/${plantId}`, // 구버전
    ISSUE_HISTORY: `/project/${projectId}/plant-status/issue/history`, // 신버전 적용 X
    ISSUE_HISTORY_DETAIL: (plantId = ':plantId') => `/project/${projectId}/plant-status/issue/history-detail/${plantId}`, // 신버전 적용 X
    INVERTER: (plantId = ':plantId') => `/project/${projectId}/plant-status/detail/inverter/${plantId}`, // 완
    INVERTER_STAT: (plantId = ':plantId') => `/project/${projectId}/plant-status/detail/inverter-stat/${plantId}`, // 완
  }),

  EMS: '/ems', // 구버전
  EMS_NEW: (projectId = ':projectId') => (`/project/${projectId}/ems`), // 완

  DR: '/dr', // 완
  MYPAGE: '/mypage', // 완
  INQUIRY: '/inquiry', // 완

  CS_INQUIRY: {
    BASE: '/cs/inquiry',
    MAIN: '/cs/inquiry/main',
    DETAIL: (id = ':id') => `/cs/inquiry/detail/${id}`,
  },

  NOTICE: {
    BASE: '/cs/notice',
    MAIN: '/cs/notice/main',
    CREATE: '/cs/notice/create',
    DETAIL: (id = ':id') => `/cs/notice/detail/${id}`,
    EDIT: (id = ':id') => `/cs/notice/edit/${id}`,
  },

  FIRMWARE: {
    BASE: '/firmware',
    MAIN: '/firmware/main',
    CREATE: '/firmware/create',
    EDIT: (id = ':id') => `/firmware/edit/${id}`,
  },
};
